/**
 * Ожидание первого кадра. Тем же знаком, что продукт: вилка дорисовывается,
 * пока едет лента. Настоящий обрыв — другой экран, и пугать им первую
 * загрузку нельзя (07.08, владелец).
 */

export function Loading({
  say = 'собираем вилки',
  hint = 'обычно секунда-две',
}: {
  say?: string;
  hint?: string;
}): React.ReactElement {
  return (
    <div className="nx-loading" role="status">
      <svg
        viewBox="0 0 24 24"
        width="56"
        height="56"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        aria-hidden="true"
      >
        <path className="nx-loading__draw" pathLength={100} d="M8 2v7a4 4 0 0 0 8 0V2" />
        <path className="nx-loading__draw d2" pathLength={100} d="M12 2v7" />
        <path className="nx-loading__draw d3" pathLength={100} d="M12 13v9" />
      </svg>
      <b>{say}</b>
      <i>{hint}</i>
    </div>
  );
}
